import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input, Output,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ObjectUtils } from 'primeng/utils';

export const CHECKBOX_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AvanoCheckboxComponent),
  multi: true
};

@Component({
  selector: 'avano-checkbox',
  templateUrl: './avano-checkbox.component.html',
  styleUrls: ['./avano-checkbox.component.scss'],
  providers: [CHECKBOX_VALUE_ACCESSOR],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvanoCheckboxComponent implements ControlValueAccessor {
  @Input() value: unknown;

  @Input() formControl: FormControl;

  @Input() name: string;

  @Input() disabled: boolean;

  @Input() readonly: boolean;

  @Input() required: boolean;

  @Input() trueValue: any = true;

  @Input() falseValue: any = false;

  @ViewChild('acb') inputViewChild: ElementRef;

  @Input() binary: boolean;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  focused: boolean;

  control: NgControl;

  model: any;

  // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/ban-types
  public onModelChange: Function = () => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/ban-types
  public onModelTouched: Function = () => {};

  constructor(public cd: ChangeDetectorRef) {}

  //toDo: check if value is set correctly when component is initiated

  onClick(event, checkbox, focus: boolean) {
    event.preventDefault();

    if (this.disabled || this.readonly) {
      return;
    }

    this.updateModel(event);

    if (focus) {
      checkbox.focus();
    }
  }

  updateModel(event) {
    let newModelValue;

    if (!this.binary) {
      if (this.checked()) newModelValue = this.model.filter((val) => !ObjectUtils.equals(val, this.value));
      else newModelValue = this.model ? [...this.model, this.value] : [this.value];

      this.onModelChange(newModelValue);
      this.model = newModelValue;

      if (this.formControl) {
        this.formControl.setValue(newModelValue);
      }
    } else {
      newModelValue = this.checked() ? this.falseValue : this.trueValue;
      this.model = newModelValue;
      this.onModelChange(newModelValue);
    }
    this.onChange.emit({ checked: newModelValue, originalEvent: event });
  }

  handleChange(event) {
    if (!this.readonly) {
      this.updateModel(event);
    }
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }
  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  writeValue(model: any): void {
    this.model = model;
    this.cd.markForCheck();
  }

  checked() {
    return this.binary ? this.model === this.trueValue : ObjectUtils.contains(this.value, this.model);
  }

  onInputFocus() {
    this.focused = true;
  }

  onFocus() {
    this.focused = true;
  }

  onBlur() {
    this.focused = false;
    this.onModelTouched();
  }
}
